const getters = {
    notification: (state) => state.notification,
    pushnotification: (state) => state.pushnotification,
    loading: state => state.loading
};

export default getters;